export class Autorisation {
    slug: string;
    roleName: string;
    description: string;
    active: boolean;
}
